import React, { useEffect, useRef } from 'react';

import './services.scss';
import { Bookings } from '../../config';
import { PrismaServices, PrispekServices, SpektraServices } from '../../constants';
import {Navbar, Footer, ServicesCompany, ServicesClientLogin, ServicesSection} from '..';

export const ServicesPage: React.FC = React.memo(() => {
    const topRef = useRef<HTMLElement>(null);
    const prispekRef = useRef<HTMLElement>(null);
    const spektraRef = useRef<HTMLElement>(null);
    const prismaRef = useRef<HTMLElement>(null);
    useEffect(() => {
        switch (window.location.hash) {
            case '#Prispek':
                prispekRef.current?.scrollIntoView();
                break;
            case '#Spektra':
                spektraRef.current?.scrollIntoView();
                break;
            case '#Prisma':
                prismaRef.current?.scrollIntoView();
                break;
            default:
                topRef.current?.scrollIntoView();
                break;
        }
    }, []);
    return (
        <section ref={topRef}>
            <Navbar services />
            <div className='section'>
                {/*<div className='services--about'>*/}
                    <p className='services--about__how'>
                        Our specialised services:
                    </p>
                {/*</div>*/}
                <ServicesSection />
            </div>
            <Footer />
        </section>
    );
});
